module.exports = __webpack_public_path__ + "static/img/get-quote-btn.c33d3be0.png";